export default "__VITE_ASSET__rRE1xtSs__"